<template>
    <div class="modal fade" id="giftCodeAddModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered  w-[500px] ">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">Add New Gift Code</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body ">
                    <div>
                        <div class="float-left w-1/2 px-2 py-2 h-20 modal-item">
                            Gift Code:
                            <v-text-field v-model="giftCode" variant="outlined" density="compact" rounded="0">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-refresh" class=" cursor-pointer"
                                        @click="generateCouponCode(12)"></v-icon>
                                </template>
                            </v-text-field>
                        </div>
                        <div
                            class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                            Gift Amount:
                            <v-text-field v-model="price" variant="outlined" density="compact" rounded="0" type="number"
                                style=""></v-text-field>
                        </div>
                        <div class="float-left w-1/2 px-2 py-2 h-20 modal-item">
                            Coupon Code:
                            <v-text-field v-model="couponCode" variant="outlined" density="compact" rounded="0"></v-text-field>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary"
                        @click="handleCreate">Create</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, defineEmits } from 'vue';
import { useGiftCodeStore, useAlertStore } from "@/stores"

const giftCodeStore = useGiftCodeStore();
const alertStore = useAlertStore();

const buttonDisableFlag = ref(false);
const giftCode = ref('');
const couponCode = ref('');
const price = ref(0)
const emit = defineEmits(['inInput', 'submit'])

const handleCreate = () => {
    if(!giftCode.value) {
        alertStore.error("Set the gift code.")
        return;
    }
    if(!price.value) {
        alertStore.error("Set the price.")
        return;
    }

    let packageRequest = {
        giftCode: giftCode.value,
        price: price.value,
        couponCode: couponCode.value
    };

    buttonDisableFlag.value = true;
    // Send FormData to server
    giftCodeStore.createGiftCode(packageRequest).then(() => {
        giftCodeStore.loadGiftCodes();
        buttonDisableFlag.value = false;
        emit('close');
    });
};

function generateCouponCode(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // Allowed characters
    let tempCouponCode = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        tempCouponCode += characters[randomIndex];
    }

    giftCode.value = tempCouponCode;
}

</script>
